const isExternalLink = (url) => /(http(s?)):\/\//i.test(url)

export default isExternalLink
